export default "__VITE_ASSET__Jn0u8U3$__"